import { Navigate, Route, Routes } from "react-router-dom";
import { ParentQuests } from "../components/admin/ParentAdmin/KidInfo/Quests";
import { ParentNotifications } from "../components/admin/ParentAdmin/Notifications/Notifications";
import { ParentCreateNotification } from "../components/admin/ParentAdmin/Notifications/CreateNotification";
import { ParentSettings } from "../components/admin/ParentAdmin/Account/Settings";
import { ParentKidRegister } from "../components/admin/ParentAdmin/Register/Kid";
import { ParentPayment } from "../components/admin/ParentAdmin/Register/Payment/Payment";
import { ParentDashboard } from "../components/admin/ParentAdmin/Dashboard/Dashboard";
import ProtectedRoute from "../components/admin/SuperAdmin/ProtectedRoutes/ProtectedRoutes";
import { ParentPaymentUpdate } from "../components/admin/ParentAdmin/Register/Payment/PaymentUpdate";
import { ParentAdminCertificateView } from "../components/admin/ParentAdmin/KidInfo/Awards/Certificate/Certificates";
import { ParentAdminTrophyView } from "../components/admin/ParentAdmin/KidInfo/Awards/Trophy/Trophy";
import { QuestInfo } from "../components/admin/ParentAdmin/KidInfo/QuestInfo";
import ParentLayout from "../components/admin/ParentAdmin/Layout/ParentLayout";
import ParentDashboardGuard from "../components/admin/ParentAdmin/ParentDashboardGuard";

const ParentAdminRoutes = () => (
  <>
    <Routes>
      <Route
        path=""
        element={
          <ProtectedRoute requiredRole={2}>
            <ParentDashboardGuard dashboard="normal_parent">
              <ParentLayout parentType="normal_parent" />
            </ParentDashboardGuard>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ParentDashboard />} />
        <Route path="dashboard/" element={<ParentDashboard />} />
        <Route path="quests/:kidId/:kidName" element={<ParentQuests />} />
        <Route
          path="quests/:kidId/:kidName/quest/:type"
          element={<QuestInfo />}
        />
        <Route
          path="quests/:kidId/:kidName/:questId/viewCertificate"
          element={<ParentAdminCertificateView />}
        />
        <Route
          path="quests/:kidId/viewTrophy"
          element={<ParentAdminTrophyView />}
        />
        <Route path="quests" element={<ParentQuests />} />
        <Route path="notifications" element={<ParentNotifications />} />
        <Route
          path="notification/create"
          element={<ParentCreateNotification />}
        />
        <Route path="settings" element={<ParentSettings />} />
        <Route path="settings/account" element={<ParentSettings />} />
        <Route
          path="settings/billing-and-plans"
          element={<ParentSettings />}
        />
        <Route
          path="settings/billing"
          element={
            <Navigate to="/parent/settings/billing-and-plans" replace />
          }
        />

        <Route
          path="kids/register/:kidCount/:kidSubscribed"
          element={<ParentKidRegister />}
        />

        <Route path="payment" element={<ParentPayment />} />

        <Route path="payment/update" element={<ParentPaymentUpdate />} />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </>
);

export default ParentAdminRoutes;
